import { QueryConfig } from "store/utils/query-config";

export const customerPaymentMethodsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"],
  },
};
